
import Vue from "vue";
import AppGridItem from "@/components/grids/GridItem.vue";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import AppTinyInfoTotalOpen from "./TinyInfoTotalOpen.vue";
import AppTinyInfoTotalProfit from "./TinyInfoTotalProfit.vue";
import AppTinyInfoTotalRevenue from "./TinyInfoTotalRevenue.vue";
import AppTinyInfoBankSaldo from "./TinyInfoBankSaldo.vue";
import AppOpenClients from "./OpenClients.vue";
import AppRevenuePerMonthCompare from "./RevenuePerMonthCompare.vue";
import AppRevenuePerMonthTotal from "./RevenuePerMonthTotal.vue";
import AppPurchasesPerMonthCompare from "./PurchasesPerMonthCompare.vue";
import AppCashInflow from "./CashInflow.vue";
import AppTaskList from "./TaskList.vue";
import AppCalendar from "./Calendar.vue";
import AppImage from "./Image.vue";
import AppRevenueNowCompare from "./RevenueNowCompare.vue";
import AppYearOverviewPerMonth from "./YearOverviewPerMonth.vue";
import AppYearOverviewPerMonthBars from "./YearOverviewPerMonthBars.vue";
import AppRevenueLastMonthCompare from "./RevenueLastMonthCompare.vue";
import AppTinyInfoToPayVat from "./TinyInfoToPayVat.vue";
import AppTinyInfoTotalOpenPurchases from "./TinyInfoTotalOpenPurchases.vue";
import { AuthService } from "@/services";

import AppIframe from "./Iframe.vue";
import { GridEditState } from "@/utils/grid/grid-edit-state";

export default Vue.extend({
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
		state: {
			type: Object as ()=>GridEditState,
			required: true
		},
		canEdit: Boolean
	},
	computed: {
		tag():string{
			return `App${this.item.getComponentName()}`;
		},
		editMode():boolean{
			return this.state.editMode && this.canEdit;
		},
		hasSettings():boolean {
			return this.item.hasSettings();
		},
		isDevMode():boolean{
			return AuthService.isDevModeEnabled;
		},
		show():boolean {
			if (this.item.OnlyVisibleForAdmin && !this.isDevMode){
				return false;
			};
			return true;
		},
	},
	methods: {
		removeSelf(){
			let i = this.state.items.indexOf(this.item);
			if (i == -1) return;
			this.state.items.splice(i,1);
		},
		openSettings(){
			this.$emit("open-settings");
		},
		fetch(){
			let el = this.$refs.component as any;
			if (!el) return;
			if (!el.fetch) return;
			el.fetch();
		}
	},
	components: {
		AppGridItem,

		AppTinyInfoTotalOpen,
		AppTinyInfoTotalProfit,
		AppTinyInfoTotalRevenue,
		AppTinyInfoBankSaldo,
		AppOpenClients,
		AppRevenuePerMonthCompare,
		AppRevenuePerMonthTotal,
		AppPurchasesPerMonthCompare,
		AppCashInflow,
		AppTaskList,
		AppCalendar,
		AppRevenueNowCompare,
		AppYearOverviewPerMonth,
		AppRevenueLastMonthCompare,
		AppTinyInfoToPayVat,
		AppYearOverviewPerMonthBars,
		AppIframe,
		AppImage,
		AppTinyInfoTotalOpenPurchases,
	}
});
